import { render, staticRenderFns } from "./rek-sch.vue?vue&type=template&id=448363b4&scoped=true"
import script from "./rek-sch.vue?vue&type=script&lang=js"
export * from "./rek-sch.vue?vue&type=script&lang=js"
import style0 from "./rek-sch.vue?vue&type=style&index=0&id=448363b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448363b4",
  null
  
)

export default component.exports